export default __webpack_public_path__ + "static/media/ico transfer hb.dc8df744.svg";